import React, { useState, useRef, useEffect, useMemo } from "react";
import { Box, Typography, Paper } from "@mui/material";

export default function CustomEpgSelector({
  epgList = [],
  selectedProgram,
  onChange
}) {
  const storedUser = useMemo(
    () => JSON.parse(localStorage.getItem("adm_panel_user") || "{}"),
    []
  );

  const isDark = !!storedUser.darkmode;

  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  // dışarı tıklayınca kapat
  useEffect(() => {
    function handleClickOutside(e) {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selectedLabel = selectedProgram
    ? `${selectedProgram.program_name} (${selectedProgram.weekday}) (${selectedProgram.start_time} - ${selectedProgram.end_time})`
    : "Select program";

  return (
    <Box ref={containerRef} position="relative" width="100%" p={2}>
      <Typography
        variant="subtitle1"
        fontWeight={600}
        mb={1}
        sx={{ color: isDark ? "#e5e7eb" : "#111827" }}
      >
        Select Program
      </Typography>

      {/* Input */}
      <Box
        onClick={() => setOpen(!open)}
        sx={{
          border: "1px solid",
          borderColor: isDark ? "#334155" : "#d1d5db",
          backgroundColor: isDark ? "#0f172a" : "#ffffff",
          color: isDark ? "#e5e7eb" : "#111827",
          padding: "10px 14px",
          borderRadius: "8px",
          cursor: "pointer",
          fontSize: "14px",
        }}
      >
        {selectedLabel}
      </Box>

      {/* Dropdown */}
      {open && (
        <Paper
          elevation={8}
          sx={{
            position: "absolute",
            top: "calc(100% - 1px)",
            left: 0,
            right: 0,
            maxHeight: 300,
            overflowY: "auto",
            zIndex: 999,
            borderRadius: "10px",
            backgroundColor: isDark ? "#0f172a" : "#ffffff",
            border: isDark
              ? "1px solid #334155"
              : "1px solid #e5e7eb",
            boxShadow: isDark
              ? "0 20px 40px rgba(0,0,0,0.7)"
              : "0 10px 25px rgba(0,0,0,0.08)",
          }}
        >
          {epgList.map((item) => {
            const label = `${item.program_name} (${item.weekday}) (${item.start_time} - ${item.end_time})`;

            return (
              <Box
                key={item.id}
                onClick={() => {
                  onChange(item);
                  setOpen(false);
                }}
                sx={{
                  padding: "10px 14px",
                  fontSize: "14px",
                  cursor: "pointer",
                  color: isDark ? "#e5e7eb" : "#111827",
                  "&:hover": {
                    backgroundColor: isDark ? "#1e293b" : "#f3f4f6",
                  },
                }}
              >
                {label}
              </Box>
            );
          })}
        </Paper>
      )}
    </Box>
  );
}
